(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(78251);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);


/**
 * Renders the <head> section of the HTML page, including meta tags, title, and favicon.
 * @param ogImage - The URL of the Open Graph image to be displayed in social media shares.
 * @param title - The title of the page.
 * @param description - The description of the page.
 */ const Head = (param)=>{
    let { ogImage ="https://publicmarket.app/banner.png" , title ="Public Market" , description ="An open door to the world of nfts"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: "@lunarmayorxyz"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: ogImage
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:determiner",
                content: "the"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: "en"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: ogImage
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:type",
                content: "image/png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:width",
                content: "1200"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:height",
                content: "600"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:alt",
                content: "Public Market banner"
            })
        ]
    });
};


/***/ }),

/***/ 61955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(40299);
/* harmony import */ var _primitives__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21666);
/* harmony import */ var utils_chains__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67418);
/* harmony import */ var context_ChainContextProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43810);
/* harmony import */ var components_primitives_Tooltip__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79320);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25511);
/* harmony import */ var next_themes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82010);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(84113);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99603);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(59417);
/* harmony import */ var components_primitives_Dropdown__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(12623);















const ChainToggle = ()=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();
    const { chain , switchCurrentChain  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(context_ChainContextProvider__WEBPACK_IMPORTED_MODULE_4__/* .ChainContext */ .p);
    const isMounted = (0,hooks__WEBPACK_IMPORTED_MODULE_6__/* .useMounted */ .s4)();
    const { theme  } = (0,next_themes__WEBPACK_IMPORTED_MODULE_7__/* .useTheme */ .F)();
    const switchChains = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((chainOption)=>{
        if (router.query.chain) {
            Object.keys(router.query).forEach((param)=>delete router.query[param]);
            router.replace({
                pathname: router.pathname,
                query: router.query
            }, undefined, {
                shallow: true
            });
        }
        switchCurrentChain(chainOption.id);
    }, [
        router.query,
        switchCurrentChain
    ]);
    if (!isMounted || utils_chains__WEBPACK_IMPORTED_MODULE_3__/* ["default"].length */ .ZP.length === 1) {
        return null;
    }
    if (utils_chains__WEBPACK_IMPORTED_MODULE_3__/* ["default"].length */ .ZP.length > 4) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_11__/* .Root */ .fC, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_11__/* .Trigger */ .xz, {
                    asChild: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                        color: "gray3",
                        css: {
                            px: "14px",
                            justifyContent: "space-between",
                            width: "auto",
                            minWidth: "max-content",
                            "@md": {
                                minWidth: "max-content",
                                px: "$4"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: theme === "dark" ? chain.darkIconUrl : chain.lightIconUrl,
                                style: {
                                    height: 20
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                style: "body1",
                                children: chain.name
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                                css: {
                                    color: "$gray10",
                                    transition: "transform",
                                    "[data-state=open] &": {
                                        transform: "rotate(180deg)"
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_9__/* .FontAwesomeIcon */ .G, {
                                    icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_12__/* .faChevronDown */ .ptq,
                                    width: 16
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives_Dropdown__WEBPACK_IMPORTED_MODULE_10__/* .DropdownMenuContent */ .AW, {
                    css: {
                        mt: "$2",
                        zIndex: 1000,
                        width: "auto",
                        minWidth: "max-content",
                        "@md": {
                            minWidth: "max-content"
                        }
                    },
                    children: utils_chains__WEBPACK_IMPORTED_MODULE_3__/* ["default"].map */ .ZP.map((supportedChain)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives_Dropdown__WEBPACK_IMPORTED_MODULE_10__/* .DropdownMenuItem */ .Xi, {
                            css: {
                                py: "$3",
                                px: "$1",
                                display: "flex",
                                gap: "$2"
                            },
                            onClick: ()=>{
                                const newUrl = router.asPath.replace(chain.routePrefix, supportedChain.routePrefix);
                                switchCurrentChain(supportedChain.id);
                                router.replace(newUrl, undefined, {
                                    scroll: false
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                                    css: {
                                        width: 30
                                    },
                                    justify: "center",
                                    align: "center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: theme === "dark" ? supportedChain.darkIconUrl : supportedChain.lightIconUrl,
                                        style: {
                                            height: 20
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                    style: "body1",
                                    children: supportedChain.name
                                })
                            ]
                        }, supportedChain.id))
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .ToggleGroup */ .tX, {
        type: "single",
        value: chain.name,
        children: utils_chains__WEBPACK_IMPORTED_MODULE_3__/* ["default"].map */ .ZP.map((chainOption)=>{
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_13__/* .Root */ .fC, {
                delayDuration: 0,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_13__/* .Trigger */ .xz, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .ToggleGroupItem */ .GX, {
                            asChild: true,
                            value: chainOption.name,
                            disabled: chainOption.name === chain.name,
                            onClick: ()=>{
                                const newUrl = router.asPath.replace(chain.routePrefix, chainOption.routePrefix);
                                switchCurrentChain(chainOption.id);
                                router.replace(newUrl, undefined, {
                                    scroll: false
                                });
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                                css: {
                                    width: 56,
                                    display: "flex",
                                    justifyContent: "center"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: theme === "dark" ? chainOption.darkIconUrl : chainOption.lightIconUrl,
                                    style: {
                                        height: 20
                                    }
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_13__/* .Content */ .VY, {
                        sideOffset: -4,
                        side: "top",
                        align: "center",
                        style: {
                            zIndex: 100,
                            filter: "drop-shadow(0px 3px 8px rgba(0, 0, 0, 0.3))"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives_Tooltip__WEBPACK_IMPORTED_MODULE_5__/* .TooltipArrow */ .C, {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                                css: {
                                    zIndex: 9999,
                                    $$shadowColor: "$colors$panelShadow",
                                    boxShadow: "0px 1px 5px rgba(0,0,0,0.2)",
                                    borderRadius: 8,
                                    overflow: "hidden"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                                    css: {
                                        background: "$neutralBgSubtle",
                                        p: "$2"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                        style: "body3",
                                        as: "p",
                                        children: chainOption === null || chainOption === void 0 ? void 0 : chainOption.name
                                    })
                                })
                            })
                        ]
                    })
                ]
            }, chainOption.name);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ChainToggle);


/***/ }),

/***/ 53593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _primitives__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21666);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99603);
/* harmony import */ var _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93024);




const SectionTitle = (param)=>/*#__PURE__*/ {
    let { title  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
        style: "subtitle1",
        css: {
            mb: 8
        },
        children: title
    });
};
const SectionLink = (param)=>/*#__PURE__*/ {
    let { name , href  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Anchor */ .ee, {
        target: "_blank",
        rel: "noopener noreferrer",
        href: href,
        weight: "medium",
        css: {
            fontSize: 14,
            mt: 16
        },
        children: name
    });
};
const developerSectionLinks = [
    {
        name: "Intro Blog",
        href: "mirror.xyz"
    },
    {
        name: "Github",
        href: "https://github.com/reservoirprotocol"
    }
];
const companySectionLinks = [
    {
        name: "Terms of Use",
        href: "https://reservoir.tools/terms"
    },
    {
        name: "Privacy Policy",
        href: "https://reservoir.tools/privacy"
    }
];
const Footer = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
        justify: "between",
        css: {
            borderTop: "1px solid $gray7",
            borderStyle: "solid",
            p: "$5",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: 36,
            "@bp600": {
                flexDirection: "row",
                gap: 0
            }
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                css: {
                    gap: 80,
                    "@bp600": {
                        gap: 136
                    }
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionTitle, {
                                title: "Resources"
                            }),
                            developerSectionLinks.map((props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionLink, {
                                    ...props
                                }, props.name))
                        ]
                    }),
                     false && /*#__PURE__*/ 0
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                direction: "column",
                css: {
                    alignItems: "flex-start",
                    "@bp600": {
                        alignItems: "flex-end"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionTitle, {
                        title: "Come talk to us"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                        css: {
                            gap: "$4",
                            mt: 16
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            target: "_blank",
                            rel: "noopener noreferrer",
                            href: "https://twitter.com/lunarmayorxyz",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                size: "xs",
                                color: "gray3",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
                                    icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_3__/* .faTwitter */ .mdU,
                                    width: 14,
                                    height: 14
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 12623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AW": function() { return /* binding */ DropdownMenuContent; },
/* harmony export */   "Lt": function() { return /* binding */ Dropdown; },
/* harmony export */   "Xi": function() { return /* binding */ DropdownMenuItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var stitches_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50530);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84113);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12664);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21190);





const DropdownMenuContent = (0,stitches_config__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)(_radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_3__/* .DropdownMenuContent */ .AW, {
    mx: "$4",
    p: "$2",
    borderRadius: 8,
    zIndex: 5,
    background: "$dropdownBg",
    $$borderColor: "$colors$gray7",
    boxShadow: "0 0 0 1px $$borderColor"
});
const AnimatedDropdownMenuContent = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)((param, forwardedRef)=>/*#__PURE__*/ {
    let { children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DropdownMenuContent, {
        asChild: true,
        forceMount: true,
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .motion.div */ .E.div, {
            ref: forwardedRef,
            initial: {
                scale: 0.9,
                opacity: 0,
                y: -20
            },
            animate: {
                scale: 1,
                opacity: 1,
                y: 0,
                transition: {
                    mass: 0.05,
                    type: "spring",
                    duration: 0.1
                }
            },
            exit: {
                y: -20,
                scale: 0.9,
                opacity: 0,
                transition: {
                    duration: 0.1
                }
            },
            children: children
        })
    });
});
const DropdownMenuItem = (0,stitches_config__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)(_radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_3__/* .DropdownMenuItem */ .Xi, {
    fontSize: 16,
    fontFamily: "$body",
    color: "$gray12",
    px: "$2",
    py: "$4",
    borderRadius: 8,
    outline: "none",
    cursor: "pointer",
    "&:hover": {
        backgroundColor: "$gray5"
    },
    "&:focus": {
        backgroundColor: "$gray5"
    }
});
const Dropdown = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)((param, forwardedRef)=>{
    let { children , trigger , contentProps , ...props } = param;
    const [open, setOpen] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_3__/* .Root */ .fC, {
        ...props,
        open: open,
        onOpenChange: setOpen,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_3__/* .Trigger */ .xz, {
                asChild: true,
                children: trigger
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_5__/* .AnimatePresence */ .M, {
                children: open && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AnimatedDropdownMenuContent, {
                    ref: forwardedRef,
                    ...contentProps,
                    children: children
                })
            })
        ]
    });
});



/***/ }),

/***/ 78251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/primitives/index.ts + 13 modules
var primitives = __webpack_require__(21666);
// EXTERNAL MODULE: ./components/Layout.tsx
var Layout = __webpack_require__(51943);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/home/Footer.tsx
var Footer = __webpack_require__(53593);
// EXTERNAL MODULE: ./hooks/index.ts + 6 modules
var hooks = __webpack_require__(25511);
// EXTERNAL MODULE: ./components/Head.tsx
var Head = __webpack_require__(4049);
// EXTERNAL MODULE: ./context/ChainContextProvider.tsx
var ChainContextProvider = __webpack_require__(43810);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(59417);
// EXTERNAL MODULE: ./components/primitives/Img.tsx
var Img = __webpack_require__(68916);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js + 1 modules
var index_es = __webpack_require__(99603);
// EXTERNAL MODULE: ./node_modules/@reservoir0x/reservoir-kit-ui/dist/index.module.js + 197 modules
var index_module = __webpack_require__(9836);
// EXTERNAL MODULE: ./node_modules/swr/core/dist/index.mjs
var dist = __webpack_require__(95591);
// EXTERNAL MODULE: ./utils/chains.ts
var chains = __webpack_require__(67418);
;// CONCATENATED MODULE: ./hooks/useTrendingCollections.ts



/* harmony default export */ function useTrendingCollections(options) {
    let swrOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, chainId = arguments.length > 2 ? arguments[2] : void 0;
    const client = (0,index_module/* useReservoirClient */.RW)();
    const chain = chainId !== undefined ? client === null || client === void 0 ? void 0 : client.chains.find((chain)=>chain.id === chainId) : client === null || client === void 0 ? void 0 : client.currentChain();
    console.log(chain);
    const { routePrefix  } = chains/* default.find */.ZP.find((c)=>{
        return c.id === (chain === null || chain === void 0 ? void 0 : chain.id);
    });
    const { data: topSellingData , ...topSellingSwr } = (0,dist/* default */.ZP)(routePrefix ? "/api/".concat(routePrefix, "/trendingCollections/v1") : null, null, swrOptions);
    return {
        ...topSellingSwr,
        collections: topSellingData === null || topSellingData === void 0 ? void 0 : topSellingData.collections,
        data: {
            collections: topSellingData === null || topSellingData === void 0 ? void 0 : topSellingData.collections
        },
        isValidating: topSellingSwr.isValidating
    };
}

// EXTERNAL MODULE: ./node_modules/react-markdown/lib/react-markdown.js + 127 modules
var react_markdown = __webpack_require__(48329);
// EXTERNAL MODULE: ./stitches.config.ts + 1 modules
var stitches_config = __webpack_require__(50530);
// EXTERNAL MODULE: ./node_modules/next-themes/dist/index.module.js
var dist_index_module = __webpack_require__(82010);
// EXTERNAL MODULE: ./node_modules/usehooks-ts/dist/esm/index.js + 36 modules
var esm = __webpack_require__(5678);
// EXTERNAL MODULE: ./components/common/ChainToggle.tsx
var ChainToggle = __webpack_require__(61955);
;// CONCATENATED MODULE: ./pages/index.tsx


















const StyledImage = (0,stitches_config/* styled */.zo)("img", {});
const mintStartTime = Math.floor(new Date().getTime() / 1000) - 60 * 6 * 60;
const IndexPage = (param)=>{
    let { ssr  } = param;
    var _topSellingCollectionsData_collections, _topCollection_banner, _topCollection_banner1, _topCollection_floorAsk, _topCollection_floorAsk_price, _topCollection_floorAsk_price_amount, _topCollection_floorAsk1, _topCollection_floorAsk_price1, _topCollection_floorAsk_price_currency, _topCollection_count, _topCollection_recentSales_slice, _topCollection_recentSales, _topCollection_floorAsk2, _topCollection_floorAsk_price2, _topCollection_floorAsk_price_amount1, _topCollection_floorAsk3, _topCollection_floorAsk_price3, _topCollection_floorAsk_price_currency1;
    const isMounted = (0,hooks/* useMounted */.s4)();
    const marketplaceChain = (0,hooks/* useMarketplaceChain */.gw)();
    const [fillType, setFillType] = (0,react.useState)("sale");
    const [minutesFilter, setMinutesFilter] = (0,react.useState)(1440);
    const [showBlogPost, setShowBlogPost] = (0,esm/* useLocalStorage */._)("showBlogPost1", true);
    // not sure if there is a better way to fix this
    const { theme: nextTheme  } = (0,dist_index_module/* useTheme */.F)();
    const [theme, setTheme] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        if (nextTheme) {
            setTheme(nextTheme);
        }
    }, [
        nextTheme
    ]);
    const { chain , switchCurrentChain  } = (0,react.useContext)(ChainContextProvider/* ChainContext */.p);
    const { data: topSellingCollectionsData , collections: collectionsData , isValidating  } = useTrendingCollections({}, {
        revalidateOnMount: true,
        refreshInterval: 300000
    }, chain === null || chain === void 0 ? void 0 : chain.id);
    const topCollection = topSellingCollectionsData === null || topSellingCollectionsData === void 0 ? void 0 : (_topSellingCollectionsData_collections = topSellingCollectionsData.collections) === null || _topSellingCollectionsData_collections === void 0 ? void 0 : _topSellingCollectionsData_collections[0];
    var _topCollection_banner_replace, _topCollection_floorAsk_price_amount_native;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                css: {
                    p: 24,
                    height: "100%",
                    "@bp800": {
                        px: "$5"
                    },
                    "@xl": {
                        px: "$6"
                    }
                },
                children: [
                    showBlogPost && isMounted && /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        align: "center",
                        justify: "between",
                        css: {
                            maxWidth: 1820,
                            mx: "auto",
                            p: 24,
                            mb: "$3",
                            borderRadius: 12,
                            background: "$neutralBgSubtle",
                            cursor: "pointer",
                            $$shadowColor: "$colors$panelShadow",
                            boxShadow: "0 0px 12px 0px $$shadowColor",
                            gap: "$4",
                            "&:hover > div > button:nth-child(1)": {
                                opacity: 1
                            },
                            "&:hover > div > button:nth-child(2)": {
                                background: "$gray2",
                                outline: "1px solid $colors$gray9"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                align: "center",
                                css: {
                                    gap: "$4"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: free_solid_svg_icons/* faBook */.FL8,
                                        color: "black",
                                        size: "2x"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        css: {
                                            fontWeight: 700,
                                            opacity: 0.9,
                                            fontSize: "14px",
                                            "@md": {
                                                fontSize: "16px"
                                            }
                                        },
                                        style: "subtitle1",
                                        children: "Read about why we built this marketplace"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                css: {
                                    gap: "$5"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                        size: "large",
                                        color: "ghost",
                                        css: {
                                            display: "none",
                                            "@md": {
                                                display: "block"
                                            },
                                            outline: "1px solid rgba(0,0,0,0)",
                                            opacity: 0,
                                            transition: "opacity 300ms ease-in-out, outline 300ms ease-in-out, background 300ms ease-in-out"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                            css: {
                                                gap: "$4"
                                            },
                                            align: "center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                onClick: ()=>{
                                                    setShowBlogPost(false);
                                                },
                                                style: "h6",
                                                children: "Hide"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                        size: "large",
                                        color: "gray3",
                                        css: {
                                            display: "none",
                                            "@md": {
                                                display: "block"
                                            },
                                            background: "$gray1",
                                            outline: "1px solid rgba(0,0,0,0)",
                                            transition: "outline 300ms ease-in-out, background 300ms ease-in-out"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                            css: {
                                                gap: "$4"
                                            },
                                            align: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                    style: "h6",
                                                    children: "Open Post"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                    icon: free_solid_svg_icons/* faChevronRight */._tD
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/".concat(chain.routePrefix, "/collection/").concat(topCollection === null || topCollection === void 0 ? void 0 : topCollection.id),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                css: {
                                    "&:hover button": {
                                        background: "$gray2"
                                    },
                                    minHeight: 540,
                                    flex: 1,
                                    overflow: "hidden",
                                    position: "relative",
                                    gap: "$5",
                                    p: "$4",
                                    display: "none",
                                    "@md": {
                                        p: "$5",
                                        gap: "$4",
                                        flexDirection: "column",
                                        display: "flex"
                                    },
                                    "@lg": {
                                        flexDirection: "row",
                                        p: "$5",
                                        gap: "$5",
                                        mt: "$4"
                                    },
                                    "@xl": {
                                        p: "$6",
                                        gap: "$6"
                                    },
                                    mb: "$6",
                                    maxWidth: 1820,
                                    mx: "auto",
                                    borderRadius: 16,
                                    //background: '$gray3',
                                    backgroundSize: "cover",
                                    border: "1px solid $gray5",
                                    backgroundImage: theme === "light" ? "url(".concat(topCollection === null || topCollection === void 0 ? void 0 : (_topCollection_banner = topCollection.banner) === null || _topCollection_banner === void 0 ? void 0 : _topCollection_banner.replace("w=500", "w=4500"), ") ") : "$gray3",
                                    backgroundColor: "$gray5"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                        css: {
                                            position: "absolute",
                                            top: 0,
                                            display: theme === "light" ? "block" : "none",
                                            zIndex: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            backdropFilter: "blur(20px)",
                                            background: "rgba(255, 255, 255, 0.9)"
                                        }
                                    }),
                                    (topSellingCollectionsData === null || topSellingCollectionsData === void 0 ? void 0 : topSellingCollectionsData.collections) && topSellingCollectionsData.collections.length && topCollection && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                                                css: {
                                                    flex: 2,
                                                    position: "relative",
                                                    zIndex: 5,
                                                    "@xl": {
                                                        flex: 3
                                                    }
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                                                        src: (_topCollection_banner_replace = topCollection === null || topCollection === void 0 ? void 0 : (_topCollection_banner1 = topCollection.banner) === null || _topCollection_banner1 === void 0 ? void 0 : _topCollection_banner1.replace("w=500", "w=4500")) !== null && _topCollection_banner_replace !== void 0 ? _topCollection_banner_replace : topCollection === null || topCollection === void 0 ? void 0 : topCollection.image,
                                                        css: {
                                                            width: "100%",
                                                            borderRadius: 8,
                                                            height: 320,
                                                            "@lg": {
                                                                height: 540
                                                            },
                                                            objectFit: "cover"
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                                        css: {
                                                            position: "absolute",
                                                            left: "$4",
                                                            "@lg": {
                                                                top: "$4"
                                                            },
                                                            bottom: "$4"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Img/* default */.Z, {
                                                            alt: "collection image",
                                                            width: 100,
                                                            height: 100,
                                                            style: {
                                                                display: "block",
                                                                borderRadius: 8,
                                                                border: "2px solid rgba(255,255,255,0.6)"
                                                            },
                                                            src: topCollection === null || topCollection === void 0 ? void 0 : topCollection.image
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                                css: {
                                                    flex: 2,
                                                    zIndex: 4
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                    direction: "column",
                                                    css: {
                                                        height: "100%"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                                                            css: {
                                                                flex: 1
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                    style: "h3",
                                                                    css: {
                                                                        mt: "$3",
                                                                        mb: "$2"
                                                                    },
                                                                    as: "h3",
                                                                    children: topCollection.name
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                    style: "body1",
                                                                    as: "p",
                                                                    css: {
                                                                        maxWidth: 720,
                                                                        lineHeight: 1.5,
                                                                        display: "-webkit-box",
                                                                        WebkitLineClamp: 3,
                                                                        WebkitBoxOrient: "vertical",
                                                                        overflow: "hidden",
                                                                        textOverflow: "ellipsis"
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_markdown/* ReactMarkdown */.D, {
                                                                        children: (topCollection === null || topCollection === void 0 ? void 0 : topCollection.description) || ""
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                                    css: {
                                                                        mt: "$4"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                                                                            css: {
                                                                                mr: "$5"
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                                    style: "subtitle2",
                                                                                    color: "subtle",
                                                                                    children: "FLOOR"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                                                                    css: {
                                                                                        mt: "$1"
                                                                                    },
                                                                                    amount: (_topCollection_floorAsk_price_amount_native = topCollection === null || topCollection === void 0 ? void 0 : (_topCollection_floorAsk = topCollection.floorAsk) === null || _topCollection_floorAsk === void 0 ? void 0 : (_topCollection_floorAsk_price = _topCollection_floorAsk.price) === null || _topCollection_floorAsk_price === void 0 ? void 0 : (_topCollection_floorAsk_price_amount = _topCollection_floorAsk_price.amount) === null || _topCollection_floorAsk_price_amount === void 0 ? void 0 : _topCollection_floorAsk_price_amount.native) !== null && _topCollection_floorAsk_price_amount_native !== void 0 ? _topCollection_floorAsk_price_amount_native : 0,
                                                                                    textStyle: "h4",
                                                                                    logoHeight: 24,
                                                                                    address: topCollection === null || topCollection === void 0 ? void 0 : (_topCollection_floorAsk1 = topCollection.floorAsk) === null || _topCollection_floorAsk1 === void 0 ? void 0 : (_topCollection_floorAsk_price1 = _topCollection_floorAsk1.price) === null || _topCollection_floorAsk_price1 === void 0 ? void 0 : (_topCollection_floorAsk_price_currency = _topCollection_floorAsk_price1.currency) === null || _topCollection_floorAsk_price_currency === void 0 ? void 0 : _topCollection_floorAsk_price_currency.contract
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                                                                            css: {
                                                                                mr: "$4"
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                                    style: "subtitle2",
                                                                                    color: "subtle",
                                                                                    children: "24H SALES"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                                    style: "h4",
                                                                                    as: "h4",
                                                                                    css: {
                                                                                        mt: 2
                                                                                    },
                                                                                    children: (_topCollection_count = topCollection.count) === null || _topCollection_count === void 0 ? void 0 : _topCollection_count.toLocaleString()
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                                                                    css: {
                                                                        display: "none",
                                                                        "@lg": {
                                                                            display: "block"
                                                                        }
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                            style: "subtitle2",
                                                                            color: "subtle",
                                                                            as: "p",
                                                                            css: {
                                                                                mt: "$4"
                                                                            },
                                                                            children: "RECENT SALES"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                                            css: {
                                                                                mt: "$2",
                                                                                gap: "$3"
                                                                            },
                                                                            children: [
                                                                                (_topCollection_recentSales_slice = topCollection === null || topCollection === void 0 ? void 0 : (_topCollection_recentSales = topCollection.recentSales) === null || _topCollection_recentSales === void 0 ? void 0 : _topCollection_recentSales.slice(0, 3)) === null || _topCollection_recentSales_slice === void 0 ? void 0 : _topCollection_recentSales_slice.map((sale)=>{
                                                                                    var _sale_token;
                                                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                                                                        css: {
                                                                                            flex: 1,
                                                                                            aspectRatio: "1/1"
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                            style: {
                                                                                                borderRadius: 4
                                                                                            },
                                                                                            src: (sale === null || sale === void 0 ? void 0 : (_sale_token = sale.token) === null || _sale_token === void 0 ? void 0 : _sale_token.image) || topCollection.image
                                                                                        })
                                                                                    });
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                                                                    css: {
                                                                                        flex: 1
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                                                                    css: {
                                                                                        flex: 1
                                                                                    }
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                            css: {
                                                                gap: "$4",
                                                                mt: "$5"
                                                            },
                                                            children: [
                                                                 false && /*#__PURE__*/ 0,
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: "/".concat(chain.routePrefix, "/collection/").concat(topCollection.id),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                                                        color: "gray4",
                                                                        css: {
                                                                            background: "white"
                                                                        },
                                                                        size: "large",
                                                                        children: "Explore Collection"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        justify: "between",
                        align: "center",
                        css: {
                            flexWrap: "wrap",
                            mb: "$4",
                            gap: "$3"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                style: "h4",
                                as: "h4",
                                children: "Trending Collections"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChainToggle/* default */.Z, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                        css: {
                            pt: "$2",
                            mb: "$4",
                            display: "grid",
                            gap: "$4",
                            gridTemplateColumns: "repeat(1, 1fr)",
                            "@sm": {
                                gridTemplateColumns: "repeat(2, 1fr)"
                            },
                            "@lg": {
                                gridTemplateColumns: "repeat(4, 1fr)"
                            }
                        },
                        children: (topSellingCollectionsData === null || topSellingCollectionsData === void 0 ? void 0 : topSellingCollectionsData.collections) && topSellingCollectionsData.collections.length && topSellingCollectionsData.collections.slice(1, 9).map((collection)=>{
                            var _collection_banner, _collection_recentSales__token, _collection_recentSales, _collection_recentSales__token_image, _collection_banner1, _collection_recentSales__token1, _collection_recentSales1, _collection_floorAsk, _collection_floorAsk_price, _collection_floorAsk_price_amount, _collection_floorAsk1, _collection_floorAsk_price1, _collection_floorAsk_price_currency, _collection_count, _collection_floorAsk2, _collection_floorAsk_price2, _collection_floorAsk_price_amount1;
                            var _collection_banner_replace, _collection_floorAsk_price_amount_native;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/".concat(marketplaceChain.routePrefix, "/collection/").concat(collection.id),
                                style: {
                                    display: "grid"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                    direction: "column",
                                    css: {
                                        flex: 1,
                                        width: "100%",
                                        borderRadius: 12,
                                        cursor: "pointer",
                                        height: "100%",
                                        background: "$neutralBgSubtle",
                                        $$shadowColor: "$colors$panelShadow",
                                        boxShadow: "0 0px 12px 0px $$shadowColor",
                                        overflow: "hidden",
                                        position: "relative",
                                        p: "$3",
                                        "&:hover > div > div> img:nth-child(1)": {
                                            transform: "scale(1.075)"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        direction: "column",
                                        css: {
                                            zIndex: 2,
                                            position: "relative",
                                            flex: 1,
                                            width: "100%"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                                                css: {
                                                    position: "relative",
                                                    overflow: "hidden",
                                                    borderRadius: 8
                                                },
                                                children: [
                                                    (collection === null || collection === void 0 ? void 0 : (_collection_banner = collection.banner) === null || _collection_banner === void 0 ? void 0 : _collection_banner.length) || ((_collection_recentSales__token = (_collection_recentSales = collection.recentSales) === null || _collection_recentSales === void 0 ? void 0 : _collection_recentSales[0].token) === null || _collection_recentSales__token === void 0 ? void 0 : (_collection_recentSales__token_image = _collection_recentSales__token.image) === null || _collection_recentSales__token_image === void 0 ? void 0 : _collection_recentSales__token_image.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: (_collection_banner_replace = collection === null || collection === void 0 ? void 0 : (_collection_banner1 = collection.banner) === null || _collection_banner1 === void 0 ? void 0 : _collection_banner1.replace("w=500", "w=1200")) !== null && _collection_banner_replace !== void 0 ? _collection_banner_replace : (_collection_recentSales__token1 = (_collection_recentSales1 = collection.recentSales) === null || _collection_recentSales1 === void 0 ? void 0 : _collection_recentSales1[0].token) === null || _collection_recentSales__token1 === void 0 ? void 0 : _collection_recentSales__token1.image,
                                                        style: {
                                                            transition: "transform 300ms ease-in-out",
                                                            width: "100%",
                                                            borderRadius: 8,
                                                            height: 250,
                                                            objectFit: "cover"
                                                        }
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                                        css: {
                                                            width: "100%",
                                                            borderRadius: 8,
                                                            height: 250,
                                                            background: "$gray3"
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Img/* default */.Z, {
                                                        src: collection === null || collection === void 0 ? void 0 : collection.image,
                                                        alt: collection === null || collection === void 0 ? void 0 : collection.name,
                                                        width: 72,
                                                        height: 72,
                                                        css: {
                                                            width: 72,
                                                            height: 72,
                                                            border: "2px solid rgba(255,255,255,0.6)",
                                                            position: "absolute",
                                                            bottom: "$3",
                                                            left: "$3",
                                                            borderRadius: 8
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                                css: {
                                                    my: "$4",
                                                    mb: "$2"
                                                },
                                                justify: "between",
                                                align: "center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                    style: "h5",
                                                    as: "h5",
                                                    ellipsify: true,
                                                    css: {
                                                        flex: 1
                                                    },
                                                    children: collection === null || collection === void 0 ? void 0 : collection.name
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                style: "body1",
                                                as: "p",
                                                css: {
                                                    maxWidth: 720,
                                                    lineHeight: 1.5,
                                                    flex: 1,
                                                    display: "-webkit-box",
                                                    WebkitLineClamp: 3,
                                                    WebkitBoxOrient: "vertical",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_markdown/* ReactMarkdown */.D, {
                                                    children: (collection === null || collection === void 0 ? void 0 : collection.description) || ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                css: {
                                                    mt: "$4"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                                                        css: {
                                                            mr: "$5"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                style: "subtitle2",
                                                                color: "subtle",
                                                                children: "FLOOR"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                                                css: {
                                                                    mt: "$1"
                                                                },
                                                                amount: (_collection_floorAsk_price_amount_native = collection === null || collection === void 0 ? void 0 : (_collection_floorAsk = collection.floorAsk) === null || _collection_floorAsk === void 0 ? void 0 : (_collection_floorAsk_price = _collection_floorAsk.price) === null || _collection_floorAsk_price === void 0 ? void 0 : (_collection_floorAsk_price_amount = _collection_floorAsk_price.amount) === null || _collection_floorAsk_price_amount === void 0 ? void 0 : _collection_floorAsk_price_amount.native) !== null && _collection_floorAsk_price_amount_native !== void 0 ? _collection_floorAsk_price_amount_native : 0,
                                                                textStyle: "h6",
                                                                logoHeight: 20,
                                                                address: collection === null || collection === void 0 ? void 0 : (_collection_floorAsk1 = collection.floorAsk) === null || _collection_floorAsk1 === void 0 ? void 0 : (_collection_floorAsk_price1 = _collection_floorAsk1.price) === null || _collection_floorAsk_price1 === void 0 ? void 0 : (_collection_floorAsk_price_currency = _collection_floorAsk_price1.currency) === null || _collection_floorAsk_price_currency === void 0 ? void 0 : _collection_floorAsk_price_currency.contract
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                                                        css: {
                                                            mr: "$4"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                style: "subtitle2",
                                                                color: "subtle",
                                                                children: "24H SALES"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                style: "h6",
                                                                as: "h4",
                                                                css: {
                                                                    mt: 2
                                                                },
                                                                children: (_collection_count = collection.count) === null || _collection_count === void 0 ? void 0 : _collection_count.toLocaleString()
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                             false && /*#__PURE__*/ 0
                                        ]
                                    })
                                })
                            });
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                        css: {
                            my: "$5"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/".concat(marketplaceChain.routePrefix, "/collection-rankings"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                children: "See More"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* Footer */.$, {})
        ]
    });
};
/* harmony default export */ var pages = (IndexPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7948,3160,3334,8329,1943,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);